import script from "./OpportunityTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OpportunityTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__